import { Platform, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

// Check if device is low-end based on viewport and platform
export const isLowEndDevice = () => {
  // Mobile devices with small screens are often lower-powered
  if (Platform.OS !== 'web' && width < 380) {
    return true;
  }
  
  // Check for reduced motion preference
  if (Platform.OS === 'web') {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return true;
    
    // Check for low memory
    // @ts-expect-error - navigator.deviceMemory is not recognized in TypeScript's DOM lib
    if (navigator.deviceMemory && navigator.deviceMemory < 4) {
      return true;
    }
    
    // Check for slow connection
    // @ts-expect-error - navigator.connection types are not fully supported in TypeScript's DOM lib
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && connection.effectiveType && ['slow-2g', '2g'].includes(connection.effectiveType)) {
      return true;
    }
  }
  
  return false;
};

// Animation duration multiplier for low-end devices
export const getAnimationDuration = (baseDuration: number): number => {
  return isLowEndDevice() ? baseDuration * 0.5 : baseDuration;
};

// Check if animations should be disabled
export const shouldDisableAnimations = (): boolean => {
  return isLowEndDevice();
};

// Get optimized shadow values based on device
export const getOptimizedShadow = (defaultShadow: any) => {
  if (isLowEndDevice()) {
    return {
      ...defaultShadow,
      shadowOpacity: defaultShadow.shadowOpacity * 0.5,
      shadowRadius: Math.min(defaultShadow.shadowRadius * 0.5, 4),
      elevation: Math.min(defaultShadow.elevation * 0.5, 2),
    };
  }
  return defaultShadow;
}; 